/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/9/19
 * Time: 12:37 PM
 */
import React, {Component} from 'react';
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import {MDBDataTable} from "mdbreact";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Button as SementicBtn} from "semantic-ui-react";
import './ViewAllCorporate.css'
import Update from "./Update/Update";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import Carousel, {Modal, ModalGateway} from 'react-images';
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../axios/axios_api_services";

class App extends Component {
  state = {
    isUpdate: false,
    corporate_data: null,
    data: [],
    images_popup: [],
    is_images_popup: false
  };

  handleUpdate = () => {
    this.setState({
      isUpdate: !this.state.isUpdate
    })
  };

  updateCorporate = (obj) => {
    this.handleUpdate();
    this.setState({
      corporate_data: obj
    });
  };

  getData = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.corporateList
          })
        } else {
          this.setState({
            data: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getData()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  convert = (date) => {
    let d = new Date(date);
    d = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2);
    return d;
  };
  openImages = (images) => {
    let array = [];
    array.push({src: images});
    this.setState({
      images_popup: array,
      is_images_popup: true
    });
  };

  deleteCorporate = (id,name) => {

    swal({
      title:"Do you want to delete this corporate? First please enter \""+name+"\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if(value === name){
          this.deleteCorporate_(id)
        }else{
          common.warningAlert("Can't delete corporate", 1)
        }
      });
  };

  deleteCorporate_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.CORPORATE_SELECT(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Corporate successfully deleted", 0);
          this.clearFields();
          this.getData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteCorporate_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    this.getData();
  }

  render() {

    let rows = [];
    let all_corporates = this.state.data;
    if (all_corporates.length !== 0) {
      all_corporates.map((cor, index) => {
        const obj = {
          logo: cor.photoPath === null || cor.photoPath === "" ? null : <img onClick={() => this.openImages(cor.photoPath)} src={cor.photoPath}
                                                     className="rounded mx-auto d-block cor-logo" alt="."/>,
          code: cor.corporateCode,
          name: cor.corporateName,
          bill_contact: cor.billingContact,
          bill_mob: cor.billMobile,
          tech_contact: cor.techContact,
          tech_mob: cor.techMobile,
          added_datetime: this.convert(cor.addedDate),
          added_by: cor.addedBy,
          last_mod_datetime: cor.modifyDate === null || cor.modifyDate === "" || cor.modifyDate === 0 ? "-" : this.convert(cor.modifyDate), //this.convert(parseFloat(element.timestamp)),
          last_mod_by: cor.modifyBy === null || cor.modifyBy === "" ? "-" : cor.modifyBy,
          contract_enddate: this.convert(cor.contractEnd),
          status: cor.status === 1 ? "ACTIVE" : "INACTIVE",
          more:
            <Row style={{padding: '0px', margin: '0px'}}>
              <Col sm={12} style={{padding: '0px'}} className={"align-center"}>
                <SementicBtn circular icon='edit' className={"more-update"}
                             onClick={() => this.updateCorporate(cor)}/>
              </Col>
              {/*<Col sm={6} style={{padding: '0px'}}>*/}
                {/*<SementicBtn circular icon='trash alternate' className={"more-remove"}*/}
                             {/*onClick={() => this.deleteCorporate(cor.corporateId,cor.corporateCode)}/>*/}
              {/*</Col>*/}
            </Row>
        };
        rows.push(obj)
      })
    }

    let columns = this.props.corporate_headers;
    let table_data = {columns: this.props.corporate_headers, rows: rows};
    return (
      <Row>
        {
          this.state.isUpdate ?
            <Update refreshData={this.getData} closeModal={this.handleUpdate} data={this.state.corporate_data}/>
            : null
        }
        <Col lg="12">
          <Card>
            <CardHeader>
              Corporates Details
              <div className={"float-right"}>
                <SementicBtn circular icon='refresh' onClick={this.getData}/>
              </div>
            </CardHeader>
            <CardBody>
              <MDBDataTable
                id={"all-corporate-table"}
                searching={true}
                searchLabel={"Search Corporate"}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                // striped={true}
                bordered
                hover
                data={table_data}/>
            </CardBody>
          </Card>
        </Col>

        <ModalGateway>
          {this.state.is_images_popup ? (
            <Modal onClose={() => this.setState({is_images_popup: false})}>
              <Carousel views={this.state.images_popup}/>
            </Modal>
          ) : null}
        </ModalGateway>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
